import '@microsoft/applicationinsights-shims';
export { Sender } from "./Sender";
